import { ListColorPipe } from './list_color_pipe'
import { WidgetTransformPipe } from './widget_transform_pipe'
import { HookNamePipe } from './hook_name_pipe'

export const PIPES = [ListColorPipe, WidgetTransformPipe, HookNamePipe]
